import { Box } from 'styled-system/jsx';
import { DetailCardBodyPropsType } from '@/common/components/DetailCard/DetailCard.types.ts';

export default ({ className, children }: DetailCardBodyPropsType) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      p="20px"
      gap="15px"
      className={className}
    >
      {children}
    </Box>
  );
};
